<template>
  <!--
      作者：zhuchangtao
      时间：2021-01-19
      描述：配送-用户列表-员工
  -->
  <div>
  <el-dialog title="添加员工" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
    :close-on-press-escape="false">
    <el-form size="small" :model="form">
      <el-form-item label="员工姓名" :label-width="formLabelWidth" :rules="[{ required: true, message: '请填写姓名' }]" prop="real_name">
        <el-input v-model="form.real_name" placeholder="请输入姓名" :minLength="1"></el-input>
      </el-form-item>
      <el-form-item label="员工联系方式" :label-width="formLabelWidth" :rules="[{ required: true, message: '请填联系方式' }]" prop="mobile">
        <el-input type="textarea" v-model="form.mobile" placeholder="请输入联系方式"></el-input>
      </el-form-item>
      <el-form-item label="用户ID" :label-width="formLabelWidth" :rules="[{ required: true, message: '请填用户' }]" prop="user_id">
        <el-input type="text" v-model="form.user_id" autocomplete="off" disabled>
        <el-button slot="append" type="primary" icon="el-icon-user-solid" @click="openUserDialog" disabled>选择用户</el-button>
        </el-input>
      </el-form-item>
      <el-form-item label="员工身份：" :label-width="formLabelWidth" :rules="[{ required: true, message: '请填写员工身份' }]" prop="level">
        <el-radio-group v-model="form.level">
          <el-radio :label="1">车队长</el-radio>
          <el-radio :label="2">派送员</el-radio>
          <el-radio :label="3">仓储员</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="addUser" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
   <!--用户选择-->
  <GetUser :is_open="open_user" @close="closeUserDialog"></GetUser>
  </div>
</template>
<script>
  import DistributionApi from '@/api/distribution.js';
  import GetUser from '@/components/user/GetUser.vue';
  export default {
    components: {
      GetUser
    },
    data() {
      return {
        open_user: false,
        loading: false,
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        dialogVisible: false,





      };
    },
    props: ['open_edit', 'form'],
    created() {
      this.dialogVisible = this.open_edit;

    },
    methods: {


      /*修改*/
      addUser() {
        let self = this;
        let params = self.form;
        console.log(params);
        if(params.user_id <=0 || params.user_id == ''){

          self.$message.error('用户不能为空');
          self.loading = false;
        }
        if(params.real_name == ''){

          self.$message.error('名称不能为空');
          self.loading = false;
        }
        if(params.mobile == ''){

          self.$message.error('联系方式不能为空');
          self.loading = false;
        }
        if(params.level == ''){

          self.$message.error('身份不能为空');
          self.loading = false;
        }
        if(params.real_name != '' && params.mobile != '' && params.user_id >0 && params.level != ''){
          self.loading = true;
          DistributionApi.userEdit({
              real_name: params.real_name,
              mobile: params.mobile,
              level: params.level,
              user_id:params.user_id,

            }, true).then(data => {
              self.loading = false;
              if (data.code == 1) {
                self.$message({
                  message: '恭喜你，添加成功',
                  type: 'success'
                });
                self.dialogFormVisible(true);
              } else {
                self.loading = false;
                self.$message.error('错了哦，这是一条错误消息');
              }
            })
            .catch(error => {
              self.loading = false;
            });
        }



      },

      /*关闭弹窗*/
      dialogFormVisible(e) {
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      },
      /*打开用户弹窗*/
      openUserDialog() {
        this.open_user = true;
      },
      /*关闭用户弹窗*/
      closeUserDialog(e) {
        if (e.type != 'error') {
          this.user = e.params[0];
          this.form.user_id = e.params[0].user_id;
        }
        this.open_user = false;
      },
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/distribution/user/dialog/Edit.vue